"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Request_1 = __importDefault(require("../Request"));
const url_1 = require("url");
function directLinkRequest(url) {
    const parsedUrl = new url_1.URL(url);
    return new Request_1.default({
        scheme: parsedUrl.protocol.replace(":", ""),
        host: parsedUrl.host,
        port: parsedUrl.protocol === "https:" ? 443 : 80,
        path: `${parsedUrl.pathname}${parsedUrl.search}`,
    });
}
exports.default = directLinkRequest;
